<template>
  <el-dialog
    :visible.sync="disableDialog"
    class="dialog-address"
    width="437px"
    :title="title"
    @close='close'>
    <div>
      <span style='padding: 0 0 20px 30px;'>{{migrateTxt}}</span>
      <div class="dialog-tip-to" v-if="type==1">
        <el-form label-width="115px">
        <el-form-item label="全部迁移至：">
        <el-select v-model="transfer" style='width:80%;'>
          <el-option
          v-for="item in shelfSelect"
          :key="item.ssId"
          :label="item.shelvesName"
          :value="item.ssId"
          ></el-option>
        </el-select>
        </el-form-item>
        </el-form>

      </div>
    </div>
    <span slot="footer" class="dialog-center">
      <el-button @click="onSubmit" type="primary">确定</el-button>
      <el-button @click="cancle">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { queryBySbIdSsId, updateAllocation } from '@/api/storage/storage'
export default {
  data () {
    return {
      disableDialog: false,
      transfer: '',
      shelfSelect: [],
      title: '放弃迁移',
      migrateTxt: '确定放弃迁移方案？',
      type: 0,
      sbId: '',
      idsArr: '',
      id: '',
      distributionType: '',
      ocssIds: '',
      checkList: []
    }
  },
  methods: {
    // 迁移货架
    onInitialize (type, sbId, idsArr, id, distributionType, ocssIds, check) {
      this.checkList = check // 传过来的数组
      this.id = id
      this.distributionType = distributionType
      this.ocssIds = ocssIds
      if (type === 0) {
        this.title = '放弃迁移确认'
        this.migrateTxt = '确定放弃迁移方案？'
        this.type = 0
      } else if (type === 1) {
        this.title = '批量迁移货架'
        this.migrateTxt = '确定迁移所选产品所在货架？'
        this.type = 1
      } else if (type === 2) {
        this.title = '迁移确认'
        this.migrateTxt = '确定提交迁移方案？'
        this.type = 2
      }
      this.disableDialog = true
      this.sbId = sbId
      this.idsArr = idsArr
      this.queryBySbIdSs()
    },
    // 获取货架
    queryBySbIdSs () {
      queryBySbIdSsId(this.sbId).then(res => {
        if (res.data.code === 200) {
          this.shelfSelect = res.data.obj
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 提交
    onSubmit () {
      if (this.type === 2) { // 迁移确认
        const params = {
          storageMigrationVoList: this.idsArr
        }
        updateAllocation(params).then(res => {
          if (res.data.code === 200) {
            this.disableDialog = false
            this.$message.success('操作成功')
            // if (this.$route.query.distributionType === 1) {
            this.$router.push({ name: 'stockDetails', query: { id: this.id, stockupState: 3, distributionType: 1, ocssIds: this.ocssIds } })
            // } else {
            //   this.$router.push({ name: 'stockProcessed', query: { id: this.id, stockupState: 3, distributionType: 2, ocssIds: this.ocssIds } })
            // }
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
          console.log(err)
        })
      } else if (this.type === 1) { // 批量迁移
        if (this.transfer === '') {
          this.$message.error('请选择迁移需要迁移的货架')
        } else {
          // 设置过滤掉相同货架的数据
          const ids = []
          this.idsArr.forEach(ele => {
            if (ele.ssId !== this.transfer) {
              ids.push({
                ssId: this.transfer,
                ocssId: ele.ocssId
              })
            }
          })
          const params = {
            storageMigrationVoList: ids
          }
          updateAllocation(params).then(res => {
            if (res.data.code === 200) {
              // 刷新列表
              this.disableDialog = false
              // if (this.$route.query.distributionType === '1') {
              this.$router.push({ name: 'stockDetails', query: { id: this.id, stockupState: 3, distributionType: 1, ocssIds: this.ocssIds } })
              //   console.log('2222')
              // } else {
              //   console.log('33')
              //   this.$router.push({ name: 'stockProcessed', query: { id: this.id, stockupState: 3, distributionType: 2, ocssIds: this.ocssIds } })
              // }
            } else {
              this.$message.error(res.data.msg)
            }
          }).catch(err => {
            console.log(err)
          })
        }
      } else { // 放弃迁移
        this.disableDialog = false
        // if (this.$route.query.distributionType === '1') {
        this.$router.push({ name: 'stockDetails', query: { id: this.id, stockupState: 3, distributionType: 1, ocssIds: this.ocssIds } })
        // } else {
        //   this.$router.push({ name: 'stockProcessed', query: { id: this.id, stockupState: 3, distributionType: 2, ocssIds: this.ocssIds } })
        // }
      }
    },
    // 取消
    cancle () {
      this.disableDialog = false
      this.transfer = ''
      this.$emit('cancle')
    },
    close () {
      this.transfer = ''
      this.$emit('cancle')
    }
  }
}
</script>
<style lang="scss" scoped>
  .dialog-tip{
    margin:10px 0 40px 30px;
    .dialog-tip-to{
      display: flex;
      margin: 10px 0;
      span{
        width: 120px;
      }
    }
  }
</style>
